import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    id: 'zVdR5B',
    defaultMessage: 'Billing Address',
    description: 'Section title for the read-only billing address summary',
  },
});
